import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { AxiosError } from 'axios';
import { QueryKey, ECookies } from '@shared/config';
import { type TFormErrorResponse } from '@shared/types';
import { authApi } from '../../authApi';
import type { User } from '../../types';

export const useShowMe = (): UseQueryResult<
  User,
  AxiosError<TFormErrorResponse>
> => {
  const getTokens = () => {
    const token = Cookies.get(ECookies.TOKEN);
    const tokenType = Cookies.get(ECookies.TOKEN_TYPE);

    return {
      token,
      tokenType,
    };
  };

  return useQuery({
    queryKey: [QueryKey.AUTH_ME_GET],
    queryFn: () => authApi.getMe(),
    enabled: !!getTokens().token && !!getTokens().tokenType,
  });
};
